import { FC } from "react";
import { TypedModalProps } from "./types";
import { Modal } from "./modal";

const SUCCESS_TITLE = "Operazione riuscita!";

export const SuccessModal: FC<TypedModalProps> = (props) => {
  const { title, ...rest } = props;
  return <Modal {...rest} type="success" title={title ?? SUCCESS_TITLE} />;
};
